export const getOtelAppEnvironment = (host: string): string => {
  if (host.includes(".cloud.capitalone.com")) return "prod";
  if (host.includes("-qa.clouddqt")) return "qa";
  if (host.includes("-dev.clouddqt")) return "dev";
  return "local";
};

export const getOtelGatewayBase = (environment: string): string => {
  if (environment === "prod") return "https://otelservices-web.cloud.capitalone.com:443";
  if (environment === "local") return "http://localhost:4318";
  return "https://otelservices-web.clouddqt.capitalone.com:443";
};
